import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Inspection } from './inspection.type';

export type InspectionAPIResponse = {
  count: number;
  values: Inspection[];
};

export type InspectionProductAPIResponse = {
  totalQuantity: number;
  values: {
    sku: string;
    quantity: number;
    name: string;
  }[];
};

export type GetAllGoodsFilterParams = {
  crateEntryEventTimestampStartDate?: number;
  crateEntryEventTimestampEndDate?: number;
  groundPositionAlias?: string;
  sku?: string;
  totalQuantity?: number;
  productDescription?: string;
  productName?: string;
  inOrderNumber?: string;
  crateEntryEventUserId?: string;
}

export type GetAllGoodsSortParams = {
  orderBy?: "sku" | "totalQuantity" | "productName" | "productDescription" | "groundPositionAlias" | "crateEntryEventTimestamp" | "inOrderNumber";
  sortBy?: "ASC" | "DESC";
}

export type GetAllGoodsParams = {
  limit: number;
  offset: number;
} & GetAllGoodsFilterParams & GetAllGoodsSortParams;


@Injectable({
  providedIn: 'root'
})
export class V3InspectionDataSourceService {
  baseUrl = environment.v3BaseUrl + '/api/v3/admin-desktop/physical-inspection';
  constructor(private http: HttpClient) { }

  getAll(params?: GetAllGoodsParams): Promise<InspectionAPIResponse> {
    return this.http.get<InspectionAPIResponse>(this.baseUrl + '/pallets', { params }).toPromise();
  }


  getInspectionProducts(params?: GetAllGoodsFilterParams): Promise<InspectionProductAPIResponse> {
    return this.http.get<InspectionProductAPIResponse>(this.baseUrl + '/product-quantities', { params }).toPromise();
  }
}
